// import { useTranslation } from 'next-i18next'
import { CgSpinner } from 'react-icons/cg'

export const Loading = () => {
    // const { t } = useTranslation()
    return (
        <div className="w-1/2 h-10 py-20 mx-auto font-bold text-center text-gray-650">
            <CgSpinner className="w-full h-10 mx-auto animate-spin" />
        </div>
    )
}
